<template>
    <div>
        <div class="wrapper" :style="getWrapperStyle">
            <div class="img-text-block" :style="getImageBlockStyle">
                <img
                        :src="activeCard.img"
                        alt="">
                <span :style="getText()"> {{activeCard.text}} </span>
            </div>
            <div class="counter">
                <span :style="getActualCounterStyle"> {{activeCard.actual}}</span>
                <span class="total">/{{activeCard.target}}</span>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'activecardwithcounter',
        props: {
            config: {},
            componentData: {},
            dimensions: {},
            colorTheme: {},
        },
        data() {
            return {
                animationFired: false
            }
        },
        methods: {},
        computed: {
            activeCard(){
                return _.find(this.componentData,{'active':true})
            },
            getImageBlockStyle(){
                return  "width:" + this.config.imageBlock.width + "; text-align:center;"
            },
            getTextValue(){
                return this.activeCard.text
            },
            getCurrentValue() {
                var self =this
                return _.reduce(this.componentData, function (sum, n) {
                    if (n.Status == self.dimensions[0]) {
                        return sum + n.Value;
                    }
                    return sum
                }, 0);
            },
            getTotalValue(){
                return _.reduce(this.componentData, function (sum, n) {
                    return sum + n.Value;
                }, 0);
            },
            getActualCounterStyle() {
                var CSS_STRING = "color:" + this.config.counter.actualColor + ";"
                return CSS_STRING
            },
            getImageStyle() {
                var CSS_STRING = "height:" + this.config.image.height + ";"
                CSS_STRING += "width:" + this.config.image.width + ";"

                return CSS_STRING
            },
            getWrapperStyle() {
                var CSS_STRING = "color:" + this.config.wrapper.color + ";"
                CSS_STRING += "background:" + this.config.wrapper.background + ";"
                CSS_STRING += "height:" + this.config.wrapper.height + ";"
                CSS_STRING += "width:" + this.config.wrapper.width + ";"
                return CSS_STRING

            }
        },
        methods:{
            getText() {
                var CSS_STRING = "color:" + this.config.text.color + ";"
                CSS_STRING += "font-size:" + this.config.text.fontSize + ";"

                return CSS_STRING
            },
        },
        watch: {
            componentData(newValue) {
                // var top = $(".counter").position().top
                // var left = $(".counter").position().left
                if (!this.animationFired)
                    if (newValue.currentValue >= newValue.totalValue) {

                    }
            }
        },
        created() {


        }
    }
</script>
<style lang="scss" scoped>
    .wrapper {
        height: 100%;
        max-height:100%;
        max-width:100%;
        .img-text-block {
            text-align: center;
            top: 50%;

            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            position: absolute;
            img {

                width:100%;
                margin:0 auto;
                padding-left: 50px;
            }
            span {
                padding-left: 50px;
                /*position: absolute;*/
                /*left: 0;*/
                top: 130%;
                text-align:center;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
                font-weight: 700;
            }

        }
        .counter {
            position: absolute;
            top: 50%;
            width: 100%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            text-align: right;
            padding-right:70px;
            font-size: 100px;
            font-weight: 700;
            vertical-align: middle;
            line-height: 10vh;
            .total {
                font-size: 100px;
            }
        }

    }


</style>